<template>
    <!-- Begin page content -->
    <main
        role="main"
        class="container-fluid"
    >
        <b-alert
            v-if="news.system && news.system.length > 0"
            variant="danger"
            show
            dismissible
            @dismissed="newsDismissed('system',news.system[0].aid)"
        >
            <strong>{{ news.system[0].title }}</strong>
            <br>{{ news.system[0].body }}
        </b-alert>
        <b-alert
            v-if="news.group && news.group.length > 0"
            variant="warning"
            show
            dismissible
            @dismissed="newsDismissed('group',news.group[0].aid)"
        >
            <strong>{{ news.group[0].title }}</strong>
            <br>{{ news.group[0].body }}
        </b-alert>
        <div class="row">
            <div class="col">
                <form
                    class="form-inline"
                    @submit.prevent="search"
                >
                    <div class="input-group mb-0">
                        <div class="input-group-prepend">
                            <b-form-select
                                v-model="selectedTeam"
                                size="sm"
                                :options="teams"
                            />
                            <b-input-group class="mb-0">
                                <b-form-input
                                    id="example-input"
                                    v-model="shot_date"
                                    size="sm"
                                    type="text"
                                    placeholder="撮影日"
                                    autocomplete="off"
                                />
                                <b-input-group-append>
                                    <b-form-datepicker
                                        id="datepicker"
                                        v-model="shot_date"
                                        button-only
                                        right
                                        aria-controls="example-input"
                                        size="sm"
                                        locale="ja"
                                        reset-button
                                        close-button
                                        calendar-width="260"
                                        :date-format-options="{ 'year': 'numeric', 'month': 'long', 'day': 'numeric', 'weekday': 'long' }"
                                        @context="onContext"
                                    />
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                        <div class="input-group mb-0">
                            <!--
                            <datepicker v-model="shot_date" :disabledDates="datePicker.disabledDates" bootstrap-styling="" input-class="text-right"
                                        style="width: 150px" clear-button="" typeable="" placeholder="日付"
                                        :calendar-button-icon="datePicker.icon" :language="datePicker.language"
                                        :format="datePicker.format"></datepicker>
                                        -->
                        </div>
                        <input
                            v-model="keyword"
                            class="form-control form-control-sm"
                            type="search"
                            placeholder="キーワード"
                            aria-label="キーワード"
                        >
                        <div class="input-group-append">
                            <button
                                class="btn btn-outline-success btn-sm"
                                type="submit"
                            >
                                <i
                                    class="icon ion-md-search"
                                /> 検索
                            </button>
                        </div>
                    </div>
                </form>
                <b-table
                    ref="table"
                    striped
                    hover
                    :items="videos"
                    :fields="fields"
                    :current-page="currentPage"
                    primary-key="vid"
                    :per-page="perPage"
                    bordered
                    small
                    show-empty
                    empty-text="結果ありません"
                    @row-clicked="rowSelected"
                    @refresh="tableRefresh"
                >
                    <template #cell(name)="data">
                        <img
                            :src="data.item.thumb?data.item.thumb:inProgress"
                            class="img-thumbnail thumb float-left mr-3"
                        >
                        <div>{{ data.value }}</div>
                        <small class="text-muted">{{ data.item.description }}</small><br>
                        <small class="text-info">{{ data.item.group }}</small><br>
                        <small class="text-warning">{{ data.item.shot_date }}</small><br>
                        <small class="text-secondary">{{ $moment(data.item.created).local().calendar() }}に追加</small>
                        <b-badge
                            v-if="user.is_manager && data.item.archived"
                            pill
                            variant="secondary"
                            class="float-right"
                        >
                            アーカイブ
                        </b-badge>
                        <b-badge
                            v-if="user.is_manager && !data.item.archived"
                            pill
                            :variant="statusVariant[data.item.status]"
                            class="float-right"
                        >
                            {{ status[data.item.status] }}
                        </b-badge>
                        <b-badge
                            v-if="data.item.shared"
                            pill
                            variant="warning"
                            class="float-right mr-1"
                        >
                            公開中
                        </b-badge>
                        <b-badge
                            v-if="data.item.data"
                            pill
                            variant="light"
                            class="float-right mr-1"
                        >
                            タグ付き
                        </b-badge>
                    </template>
                </b-table>
                <b-row>
                    <b-col class="my-1">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            class="my-0"
                            @change="changePage"
                        />
                    </b-col>
                    <b-col class="my-1">
                        <span>{{ currentRows }} / {{ totalRows }}</span>
                    </b-col>
                </b-row>
            </div>
        </div>

        <!-- video info modal -->
        <b-modal
            ref="videoInfoModal"
            centered
            hide-footer
            size="lg"
            :title="selectedItem ? selectedItem.name : ''"
            class="videoModal"
            no-enforce-focus
            body-class="video-modal-body"
            header-class="video-modal-header"
            @shown="modalShown"
        >
            <div
                v-if="selectedItem && selectedItem.status === 'ready'"
                class="thumbLarge"
                :style="{ cursor: 'pointer', 'backgroundImage': 'url(' + (selectedItem.poster?selectedItem.poster:inProgress) + ')' }"
                @click.prevent="playVideo"
            >
                <img
                    v-if="!selectedItem.archived"
                    src="@/assets/img/play-button.png"
                    alt="再生"
                    class="playbutton"
                >
            </div>
            <div
                v-if="selectedItem && selectedItem.status !== 'ready'"
                class="thumbLarge"
                :style="{backgroundImage: 'url('+inProgress+')'}"
            />
            <div
                v-if="selectedItem"
                class="card-body"
            >
                <div class="card-text mb-3 small">
                    <div>
                        <span class="font-weight-bold">詳細：</span><span
                            class="text-muted"
                            v-html="selectedItem.description"
                        />
                    </div>
                    <div>
                        <span class="font-weight-bold">日付：</span><span
                            class="text-muted"
                            v-html="selectedItem.shot_date"
                        />
                    </div>
                    <div>
                        <span class="font-weight-bold">チーム：</span><span
                            class="text-muted"
                            v-html="selectedItem.group"
                        />
                    </div>
                    <div>
                        <span class="font-weight-bold">公開チーム数：</span><span
                            class="text-muted"
                            v-html="selectedItem.sharedCnt"
                        />
                    </div>
                </div>
            </div>
            <b-button-group
                v-if="user.is_manager && selectedItem && selectedItem.group_id === user.group.group_id"
                class="no-round w-100"
            >
                <b-button
                    variant="warning"
                    title="編集"
                    @click="editVideo"
                >
                    <i class="icon ion-md-create" />
                </b-button>
                <b-button
                    variant="danger"
                    title="削除"
                    @click="deleteVideo"
                >
                    <i class="icon ion-md-trash" />
                </b-button>
                <b-button
                    v-if="selectedItem.status === 'ready' && !selectedItem.archived"
                    variant="secondary"
                    title="アーカイブ"
                    @click="archiveVideo"
                >
                    <i class="icon ion-md-archive" />
                </b-button>
                <b-button
                    v-if="selectedItem.archived"
                    variant="primary"
                    title="復元"
                    @click="restore"
                >
                    <i
                        class="icon ion-md-refresh"
                    />
                </b-button>
                <b-button
                    v-if="selectedItem.status === 'ready' && !selectedItem.archived"
                    variant="info"
                    title="DLリンク生成"
                    @click="createOneTimeURL"
                >
                    <i class="icon ion-md-code-download" />
                </b-button>
            </b-button-group>
            <b-button-group
                v-if="user.is_manager && selectedItem && selectedItem.group_id !== user.group.group_id && selectedItem.acl.find(acl=>acl.group_id === user.group.group_id && acl.download)"
                class="no-round w-100"
            >
                <b-button
                    variant="info"
                    title="DLリンク生成"
                    @click="createOneTimeURL"
                >
                    <i class="icon ion-md-code-download" />
                </b-button>
            </b-button-group>
            <b-button-group
                v-if="selectedItem && selectedItem.status === 'ready' && !selectedItem.archived && selectedItem.group_id === user.group.group_id"
                class="no-round w-100"
            >
                <b-button
                    v-if="selectedItem.data"
                    variant="success"
                    title="タグ検索"
                    @click="searchLabelVideo"
                >
                    <i class="icon ion-md-search" /> タグ検索
                </b-button>
            </b-button-group>
        </b-modal>
    </main>
</template>

<script>
// import Datepicker from 'vuejs-datepicker';
import inProgress from '@/assets/img/inprogress.svg'
import { getPlayURL } from '@/components/methodMixins.js'
import { mapState } from 'pinia'
import { store } from '@/store.js'

export default {
    name: 'MainMobile',
    mixins: [getPlayURL],
    data () {
        const fields = [
            {
                key: 'name',
                label: '映像'
            }
        ]

        return {
            inProgress,
            shot_date: '',
            keyword: '',
            news: {},
            totalRows: 0,
            currentPage: 1,
            perPage: 20,
            currentRows: '',
            fields,
            selectedItem: null,
            sortBy: 'created',
            sortDesc: true,
            selectedTeam: null,
            formatted: '',
            selected: '',
            status: {
                init: 'アップロード待ち',
                up: 'アップロード中',
                up_end: '準備中',
                up_err: 'アップロードエラー',
                enc: '準備中',
                enc_err: '準備エラー',
                ready: '利用可能'
            },
            statusVariant: {
                init: 'light',
                up: 'primary',
                up_end: 'info',
                up_err: 'danger',
                enc: 'dark',
                enc_err: 'danger',
                ready: 'success'
            }
        }
    },
    computed: {
        ...mapState(store, ['groups', 'user']),
        teams () {
            const l = this.groups.filter(item => item.contract).map(item => {
                return { text: item.name, value: item.group_id }
            })
            l.unshift({
                text: '自分のチーム', value: this.user.group.group_id
            })
            l.unshift({
                text: 'すべて', value: null
            })
            return l
        }
    },
    mounted () {
        this.$root.$on('updateNews', (news) => {
            this.news = news
        })
        this.$root.$on('updateTable', () => {
            if (this.$refs.table) {
                this.$refs.table.refresh()
            }
        })
        this.$root.$on('closeInfoModal', () => {
            if (this.$refs.videoInfoModal) {
                this.$refs.videoInfoModal.hide()
            }
        })
    },
    methods: {
        searchLabelVideo () {
            this.$root.$emit('openVideoSearchModal', this.selectedItem)
        },
        onContext (ctx) {
            // The date formatted in the locale, or the `label-no-date-selected` string
            this.formatted = ctx.selectedFormatted
            // The following will be an empty string until a valid date is entered
            this.selected = ctx.selectedYMD
        },
        tableRefresh () {
            this.selectedItem = null
        },
        search () {
            this.selectedItem = null
            /* eslint-disable no-undef */
            this.$log('search', { search_term: this.keyword })
            this.$refs.table.refresh()
        },
        modalShown () {
            this.$root.$off('focusin.modal')
            // TODO: right now not using this yet, for future use
        },
        playVideo () {
            if (this.selectedItem.archived) {
                return
            }
            this.getPlayURL(this.selectedItem, url => {
                this.$root.$emit('openVideo', url, this.selectedItem)
            })
        },
        rowSelected (item) {
            this.selectedItem = item
            this.$refs.videoInfoModal.show()
            /* eslint-disable no-undef */
            this.$log('view_item', { event_label: this.selectedItem.name })
        },
        videos (ctx, cb) {
            const params = {
                page: ctx.currentPage,
                size: ctx.perPage,
                date: this.shot_date ? this.$moment(this.shot_date).format('YYYY-MM-DD') : '',
                keyword: this.keyword,
                sort: this.sortBy,
                desc: this.sortDesc
            }

            if (this.selectedTeam) {
                params.gid = this.selectedTeam
            }

            ctx.busy = true
            this.$http.get('video/', { params }).then((response) => {
                ctx.busy = false
                this.totalRows = response.data.total
                const videos = response.data.videos.map(x => {
                    x.sharedCnt = x.acl.filter(x => x.streaming).length - 1
                    x.shared = !x.archived && x.group_id === this.user.group.group_id && x.sharedCnt > 0
                    return x
                })
                cb(videos)
                let first = 0
                if (videos.length > 0) {
                    first = ((ctx.currentPage - 1) * ctx.perPage) + 1
                    first = first + ' - ' + (first + videos.length - 1)
                } else {
                    if (this.keyword || this.shot_date) {
                        this.$snotify.warning('結果がありません')
                    }
                    this.selectedItem = null
                }
                this.currentRows = first
            }).catch((error) => {
                ctx.busy = false
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
                if (this.$ab) {
                    this.$ab.notify(error)
                }
                cb([])
                console.log(error)
            })
        },
        newsDismissed (type, aid) {
            switch (type) {
            case 'system':
                this.$ls.set('news-s', aid)
                break
            case 'group':
                this.$ls.set('news-g', aid)
                break
            }
        },
        /**
         * Create one time url
         **/
        createOneTimeURL () {
            if (this.selectedItem) {
                this.$root.$emit('createOneTimeURL', this.selectedItem)
            }
        },
        editVideo () {
            this.$root.$emit('openVideoEditModal', this.selectedItem.video_id)
        },
        /**
         * Delete selected video
         */
        deleteVideo () {
            if (this.selectedItem) {
                this.$parent.deleteVideo(this.selectedItem)
            }
        },
        archiveVideo () {
            if (this.selectedItem) {
                this.$parent.archiveVideo(this.selectedItem)
            }
        },
        changePage () {
            window.scrollTo(0, 0)
        },
        restore () {
            if (this.selectedItem) {
                this.$parent.restoreVideo(this.selectedItem)
            }
        }
    }
}
</script>

<style scoped>
.no-round .btn {
    border-radius: 0 !important;
}

</style>

<style>
.video-modal-body {
    padding: 0 !important;
}

.video-modal-header {
    padding: 0.5rem !important;
}
</style>
